import { differenceInSeconds } from 'date-fns';
import { useState } from 'react';

const useVerifySync = () => {
  const currentDate = new Date();
  const [isSynced, setIsSynced] = useState(false);

  const verifySynced = async (date: Date) => {
    if (differenceInSeconds(date, currentDate) >= 0) {
      setIsSynced(true);
    } else {
      setIsSynced(false);
    }
  };

  return { isSynced, verifySynced };
};

export default useVerifySync;
